<template>
  <div class="slider-upsale">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "UpsaleSlider",

  mounted() {
    $(function () {
      $(".slider-upsale").slick({
        arrows: true,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        prevArrow:
          '<button type="button" class="slick-prev pull-left"><svg  width="10" height="16" viewBox="0 0 10 16" fill="none"><path d="M8.04126 14.0174L2.04126 7.51739L8.04126 1.0174" stroke="black" stroke-width="3"/></svg></button>',
        nextArrow:
          '<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none"><path d="M0.918457 0.847839L6.91846 7.34784L0.918457 13.8478" stroke="black" stroke-width="2.5"/></svg></button>',
      });
    });
  },
};
</script>
<style>
.slider-upsale {
  overflow: hidden;
}
.slider-upsale.paddingX {
  padding: 0 20px;
}
.pull-left::before,
.pull-right::before {
  display: none;
}
</style>
